/**
 * User-facing copy for Industry News relevance threshold counts.
 */

export function formatIndustryNewsThresholdSummary(
  aboveThresholdCount: number,
  totalCount: number,
  thresholdPercent: number
): string {
  if (totalCount === 0) {
    return '';
  }

  const thresholdLabel = `${thresholdPercent}%`;

  if (aboveThresholdCount === 0) {
    return `${aboveThresholdCount} above ${thresholdLabel} threshold — showing all ${totalCount} ranked by relevance.`;
  }

  if (aboveThresholdCount >= totalCount) {
    return `All ${totalCount} articles meet the ${thresholdLabel} relevance threshold.`;
  }

  return `${aboveThresholdCount} above ${thresholdLabel} threshold, ${totalCount} total — below-threshold articles appear on later pages.`;
}
